import Youtube from "react-youtube";
import { useMediaQuery } from "usehooks-ts";
import CustomModal from "@axvdex/components/common/CustomModal";
import { responsiveBreakpoints } from "@axvdex/constants";
import { OutbidSale } from "@axvdex/types/solana/outbid";

type SolanaSaleDocsModalProps = {
  saleDocsModalOpen: boolean;
  setSaleDocsModalOpen: (open: boolean) => void;
  selectedOutbidSale: OutbidSale;
};

const SolanaSaleDocsModal = ({
  saleDocsModalOpen,
  setSaleDocsModalOpen,
  selectedOutbidSale,
}: SolanaSaleDocsModalProps) => {
  const isMobileBreakpoint = useMediaQuery(responsiveBreakpoints.mobileSm);

  const renderSpecificDocs = () => {
    // See ../SaleDocsModal.tsx for inspiration

    return (
      <>
        <h3>A test sale to test the Solana outbid ...</h3>
      </>
    );
  };

  return (
    <>
      <CustomModal
        extraClassName="outbidGuide"
        isOpen={saleDocsModalOpen}
        onClose={() => setSaleDocsModalOpen(false)}
        modalSize="lg"
      >
        <section className="sectionModalHeader">
          <h2 className="h2">{"Outbid"}</h2>
        </section>
        <div style={{ fontSize: "1em" }}>
          <p>Outbid is a gamified fundraising platform that combines the thrill of auctions with crowdfunding.</p>
          <div style={{ display: "flex", placeContent: "center" }}>
            <Youtube
              videoId="9aWk-G6vnKw"
              opts={{
                height: isMobileBreakpoint ? "120" : "350",
                width: isMobileBreakpoint ? "230" : "720",
                playerVars: {
                  autoplay: 0,
                  controls: 1,
                  playlist: "9aWk-G6vnKw,LdDcooCejt4,",
                  rel: 0,
                  loop: 1,
                },
              }}
              id="video_1"
            />
          </div>
          <br />
          <p>
            Projects and DAOs are enabled to raise community funds through a series of micro-sales. These sales occur
            consecutively, with each sale being more expensive than the previous one, driving up the valuation and
            ensuring that early supporters benefit from the best pricing.
          </p>
          {renderSpecificDocs()}
          <hr />
        </div>
      </CustomModal>
    </>
  );
};

export default SolanaSaleDocsModal;
